module.exports = __webpack_public_path__ + "img/logo.dac689a0.png";